export const campaignStatusEnum = {
  Scheduled: 1,
  Running: 2,
  Expired: 3,
  Inactive: 4,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};

export const campaignStatusColorEnum = colors => ({
  [campaignStatusEnum.Scheduled]: {
    color: colors.white,
    backgroundColor: colors.blueMain,
  },
  [campaignStatusEnum.Running]: {
    color: colors.white,
    backgroundColor: colors.blueMain,
  },
  [campaignStatusEnum.Expired]: {
    color: colors.white,
    backgroundColor: colors.blueMain,
  },
  [campaignStatusEnum.Inactive]: {
    color: colors.white,
    backgroundColor: colors.grey005,
  },
});
